<template>
    <div class="sub-slide">
        <div :class="`sub_${index}`" v-for="(section, index) in sections" :key="section.id">
            <div class="section">
                <Back v-if="sectionNum" class="back" @click.native="close"/>
                <div class="slide" :class="[slide.rectangle, slide.rectangle_mobile, slide.id]" :style="styles(slide, index)" style="display: none;"
                     v-for="slide in section.slides" :key="slide.id" :ref="`section_${section.id}_slide_${slide.id}`">
                    <div class="text" v-if="slide.text" v-html="slide.text"></div>
                    <img class="text-img" v-if="slide['text-image']" :src="getImgUrl(slide['text-image'])" alt="logo">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import sections from '../json/slides'
import { fromTo } from '../helpers'
import Back from './Back'

export default {
    name: 'Slide',
    components: { Back },
    props: {
        sectionNum: {
            require: true
        }
    },
    watch: {
        sectionNum: {
            deep: true,
            immediate: true,
            handler () {
                this.startAnimation()

            }
        }
    },
    data () {
        return {
            sections,
            currentSection: null
        }
    },
    methods: {
        startAnimation () {
            this.currentSection = this.sections.find(item => item.id === this.sectionNum)
            if (this.currentSection) {
                setTimeout(this.runAnimation)
            }

        },
        runAnimation () {
            
            for (const slide of this.currentSection.slides) {
                const ref = this.$refs[`section_${this.sectionNum}_slide_${slide.id}`]
                let from = slide.transition.from
                let to = slide.transition.to

                let m_from = slide.mobile_tran.from
                let m_to = slide.mobile_tran.to


                if(window.innerWidth<768)
                    fromTo(ref, m_from, m_to)
                else
                    fromTo(ref, from, to)
            }
        },

        close () {
            window.scrollTo(0,0);
            for (const slide of this.currentSection.slides) {
                const ref = this.$refs[`section_${this.sectionNum}_slide_${slide.id}`]
                let from = slide.transition.to
                let to = slide.transition.from

                let m_from = slide.mobile_tran.to
                let m_to = slide.mobile_tran.from
                if(window.innerWidth<768){
                    fromTo(ref, m_from, m_to).then((el) => {
                        el[0].style.display = 'none'
                        this.$emit('close')
                    })
                }else{
                    fromTo(ref, from, to).then((el) => {
                        el[0].style.display = 'none'
                        this.$emit('close')
                    })
                }

            }
        },

        getImgUrl (pet) {
            return require('../assets/images/' + pet)
        },

        styles (slide) {
            const backgroundImage = slide['background-image']
                ? `url(${this.getImgUrl(slide['background-image'])})`
                : 'none'
            return {
                left: '-500',
                ...slide.transition.from,
                backgroundImage,
                backgroundColor: slide['background-color']
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .section {
        width: 100%;
        height: 100%;

        .back {
            z-index: 10;
            position: fixed;
            width: 50px;
            left: 20px;
            top: 20px;
        }

        .slide {
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .text {
                color: #fff;
                font-weight: 700;
                font-size: 30px;
                text-align: center;
                line-height: 44px;
            }

            .text-img {
                margin-top: 20px;
                max-height: 100px;
                max-width: 150px;
                display: block;
            }
        }

        .slide.panel {
            height: 100%;
            width: 50%;
        }

        .slide.rectangle {
            height: 50%;
            width: 50%;
        }

        .slide.full {
            height: 100%;
            width: 100%;
        }
    }
    @media (max-width: 1380px) {
        .section {
            .slide {
                .text {
                    font-size: 20px;
                    line-height: 28px;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .section {
            height: 100%;
            overflow-y: scroll;
            .back {
                left: 14px;
                top: 4px;
                z-index: 120;
                width:35px;
            }
            .slide.panel {
                height:60%;
                width: 100%;
            }

            .slide.rectangle {
                height: 35%;
                width: 100%;
            }
            .slide {
                .text {
                    font-size: 14px;
                    line-height: 20px;
                }

                .text-img {
                    margin-top: 0px;
                    max-height: 75px;
                    max-width: 75px;
                }
            }
			.slide.top-mobile-text {
				.text {
					padding-top:45px;
				}
			}
        }
    }
</style>
